export default __webpack_public_path__ + "static/media/badge-cuivre.dd890872.png";